import "./NoContentMessage.css"

export const NoContentMessage = ({ message }) => {

    return (
        <div className="no-content-message">{message}</div>
    )
}
